<div>
    <div style="margin-left: 80%; margin-bottom: 2%">
        <button style="margin-right: 2%; margin-left: 2%" mat-raised-button color="primary" (click)="saveData()">
            Save
        </button>
        <button mat-dialog-close class="btn noPrint">Close</button>
        <button   id="print-button"  class="noPrint" style="margin-top: 2%; margin-left: 2%; display: none; " mat-raised-button color="primary"
          printSectionId="print-section"  [useExistingCss]="true"  ngxPrint>
        Print
        </button>

        <button (click)="print()" class="noPrint" style="margin-top: 2%; margin-left: 2%" mat-raised-button color="primary">
      Print
      </button>
    </div>
   <div class="report-container" id="print-section">

    <!-- Header -->
    <table class="report-table">
        <tr class="header-row">
            <td colspan="2">विवेक साप्ताहिक</td>
            <td colspan="2">जाहिरात प्रसिद्धीपत्रक</td>
            <td>Date : {{ today | date:"dd-MM-yyyy" }}</td>
            <td>Page No : 1</td>
        </tr>
        <tr>
            <td colspan="2">Date From: {{ start_date | date:"dd-MM-yyyy" }} To: {{ end_date | date:"dd-MM-yyyy" }}</td>
            <td colspan="2">Issue/Grantha Category : {{ issue_category }}</td>
            <td>Issue Date : {{ issuedatepp | date:"dd-MM-yyyy" }}</td>
            <td>Issue Name : {{ issuenamenew }}</td>
        </tr>
    </table>

    <!-- Main Table -->
    <table class="report-table">
        <thead>
            <tr>
                <th>अंक अ.</th>
                <th>नोंदणी क्र</th>
                <th>जाहिरातदाराचे नाव</th>
                <th>ग्राहकाचे नाव</th>
                <th>जाहिरात आकार</th>
                <th>जाहिरात सूचना</th>
                <th>पृष्ठ क्र</th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let data of prasiddhipatrakData; let i=index;">
                <tr>
                    <td colspan="7" style="text-align: left; font-weight: bold;">
                        जाहिरात आकार: {{data.advt_size}}
                    </td>
                </tr>

                <tr *ngFor="let data1 of data.advt_data; let j= index;">
                    <td>{{data1.advt_count}}</td>
                    <td>{{data1.booking_no}}</td>
                    <td style="font-weight: bold;">{{data1.name}}</td>
                    <td>{{data1.cust_name}}</td>
                    <td style="font-weight: bold;">{{data1.DS_advtsize}}</td>
                    <td></td>
                    <td>
                        <input type="text" style="width: 60px; height: 30px;"
                            [value]="data1['pages_no'] !== '0' ? data1['pages_no'] : ''"
                            (change)="setPanNo($event,data1)">
                    </td>
                </tr>

                <tr>
                    <td colspan="7" style="text-align: left; font-weight: bold;">
                        एकूण जाहिरात आकार {{data.advt_size}} : {{data.total_count}}
                    </td>
                </tr>
            </ng-container>
        </tbody>

        <!-- Grand Total -->
        <tfoot>
            <tr>
                <td colspan="2" style="font-weight:bold;">Total</td>
                <td colspan="2" style="font-weight:bold; text-align:center;">{{ total_count }}</td>
                <td colspan="3"></td>
            </tr>
        </tfoot>
    </table>

    <!-- Signatures -->
    <table class="report-table">
        <tr class="signature-row">
            <td colspan="2">स्वाक्षरी जाहिरात विभाग - लिपिक</td>
            <td colspan="2">दिनांक :</td>
            <td colspan="2">कार्यालय प्रमुख</td>
        </tr>
        <tr class="signature-row">
            <td colspan="2">संपादकीय विभागाकरिता - लिपिक</td>
            <td colspan="2">दिनांक :</td>
            <td colspan="2">दिनांक :</td>
        </tr>
    </table>

    <!-- Summary Example -->
  <!-- Summary Table - Dynamic -->
    <table class="report-table">
        <thead>
            <tr>
                <th>क्र.</th>
                <th>जाहिरात आकार</th>
                <th>संख्या</th>
                <th colspan="3">एकूण संख्या</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let summary of prasiddhipatraksummary; let i=index;">
                <td>{{i + 1}}</td>
                <td>{{summary.advt_size}}</td>
                <td style="text-align: right;">{{summary.total_count}}</td>
                <td colspan="3" style="text-align: right;">{{summary.total_count}}</td>
            </tr>
        </tbody>
        <tfoot>
            <tr>
                <td colspan="2" style="font-weight:bold;">Grand Total</td>
                <td style="font-weight:bold;text-align: right;">{{ getTotalAdvtCount() }}</td>
                <td colspan="3" style="font-weight:bold;text-align: right;">{{ getTotalAdvtCount() }}</td>
            </tr>
        </tfoot>
    </table>

</div>
    
    

</div>



